import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const RoleBasedRedirect: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      const user = JSON.parse(userStr);
      // All authenticated users go to main dashboard
      navigate('/dashboard', { replace: true });
    } else {
      navigate('/login', { replace: true });
    }
  }, [navigate]);

  return <div>Loading...</div>;
};

export default RoleBasedRedirect;
